import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getLocales } from 'expo-localization';
import { Platform } from 'react-native';

// Import JSON translations
import enJSON from './locales/en.json';
import viJSON from './locales/vi.json';

// Configure translation resources
const resources = {
  en: {
    translation: enJSON,
  },
  vi: {
    translation: viJSON,
  },
};

// Get locale with web compatibility
const getLocale = () => {
  if (Platform.OS === 'web') {
    // For web, use browser locale or fallback
    return navigator.language || 'en';
  } else {
    // For React Native, use modern expo-localization API
    const locales = getLocales();
    return locales?.[0]?.languageCode || 'en';
  }
};

// Initialize i18n
i18next.use(initReactI18next).init({
  resources,
  lng: getLocale(),
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  compatibilityJSON: 'v4',
  react: {
    useSuspense: false,
  },
});

export default i18next;
